import axios from "axios"
import { apiBaseUrl } from "../configs/configs"

export const getQuestions = async (match_id,series_id, dispatch, dispatchFunction) => {
    const result = await axios.get(`${apiBaseUrl}/prediction/match/${match_id}/series/${series_id}`)
    if(result.data.status === 'success'){
        dispatch(dispatchFunction(result.data.data))
    }
}

export const getChildQuestions = async (prediction_id, dispatch, dispatchFunction) => {
    const result = await axios.get(`${apiBaseUrl}/child_prediction/prediction/${prediction_id}`)
    if(result.data.status === 'success'){
        dispatch(dispatchFunction(result.data.data))
    }
}